import React from 'react';
import { VideoLibraryContainer } from './VideoLibraryContainer';

interface VideoLibraryProps {
  styleId?: string | null;
  influenceId?: string | null;
  backgroundId?: string | null;
  environmentIds?: string[];
  moodIds?: string[];
  colorIds?: string[];
  hasAudio?: boolean;
  description?: string;
  debouncedDescription?: string;
  selectedVideo?: any;
  onVideoSelect?: (video: any) => void;
}

const VideoLibrary: React.FC<VideoLibraryProps> = (props) => {
  return <VideoLibraryContainer {...props} />;
};

export default VideoLibrary; 